import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var monthButton = createRuntimeFn({defaultClassName:'fx_c76f37be_1sib86k1',variantClassNames:{isRangeStartDate:{true:'fx_c76f37be_1sib86k2'},isRangeEndDate:{true:'fx_c76f37be_1sib86k3'},isInRange:{true:'fx_c76f37be_1sib86k4'}},defaultVariants:{},compoundVariants:[[{isRangeStartDate:true,isRangeEndDate:true},'fx_c76f37be_1sib86k5'],[{isInRange:true,isRangeStartDate:false,isRangeEndDate:false},'fx_c76f37be_1sib86k6']]});
var wrapper = 'fx_c76f37be_1sib86k0';

export { monthButton, wrapper };
//# sourceMappingURL=monthCalendar.vanilla.mjs.map
